export const containerStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  width: '100%',
  p: 2,
  bgcolor: '#1a1e27',
  overflow: 'hidden',
};

export const mainCardStyles = {
  bgcolor: '#262a33',
  borderRadius: '20px',
  boxShadow:
    '0 20px 60px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.05)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 5,
  p: { xs: 5, sm: 7 },
  maxWidth: 500,
  width: '90%',
};

export const logoStyles = {
  width: { xs: 120, sm: 160 },
};

export const titleStyles = {
  fontSize: { xs: '1.75rem', sm: '2rem' },
  fontWeight: 700,
  color: '#f7fafc',
  textAlign: 'center',
  textShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
};
